<template>
	<popup v-model="vanpopup">
		<div class="popup-content">
			<div class="header" :class="`introduce_bg${memberInfo.backGroundType}`">
				<img v-if="memberInfo.photo" :src="memberInfo.photo" alt="" />
				<div class="info">
					<p class="name text-overflow">{{ memberInfo.name }}</p>
					<p class="position text-overflow2">{{ memberInfo.position }}</p>
				</div>
				<div class="close-btn" @click="handleClose"></div>
			</div>
			<p class="intro" v-if="memberInfo.abstractText">
				<span>{{ memberInfo.abstractText }}</span>
			</p>
		</div>
	</popup>
</template>

<script setup>
import { Popup } from 'vant';
import { computed } from 'vue';
const props = defineProps({
	visible: {
		type: Boolean,
		default: false
	},
	memberInfo: {
		type: Object,
		default: () => ({})
	}
});
const emits = defineEmits(['update:visible']);

const vanpopup = computed({
	get: () => {
		return props.visible;
	},
	set: newValue => {
		emits('update:visible', newValue);
	}
});

const handleClose = () => {	
	emits('update:visible', false);
};
</script>

<style lang="less" scoped>
.popup-content {
	overflow: hidden;
	.header {
		display: flex;
		padding: 20px 20px 10px 20px;
		background: url('~@/assets/images/home/mobile_corporate_bg.jpg') no-repeat;
		background-size: 100% 100%;

		img {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			margin-right: 8px;
		}

		.info {
			width: 0;
			flex: 1;
			.name {
				padding-right: 12px;
				color: var(--t-emphasis-color, #1d2129);
				 
				font-size: 18px;
				font-weight: 600;
			}
			.position {
				margin-top: 2px;
				align-self: stretch;
				color: var(--t-secondary-info-color, #86909c);
				 
				font-size: 12px;
				font-weight: 400;
				line-height: 18px; /* 150% */
			}
		}
		.close-btn {
			position: absolute;
			top: 12px;
			right: 12px;
			font-family: 'iconfont' !important;
			font-size: 24px;
			 
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			color: #4e5969;

			&:before {
				content: '\e621';
			}
		}
	}
	.intro {
		max-height: 320px;
		overflow-y: scroll;
		padding: 0 20px;
		margin: 10px 0 20px 0;
		color: #1d2129;
		text-align: justify;
		align-self: stretch;
		 
		font-size: 14px;
		font-weight: 400;
		line-height: 24px;
	}
	.introduce_bg1 {
		background: url('~@/assets/images/home/mobile_corporate_bg1.png') no-repeat;
		background-size: 100% 100%;
	}
	.introduce_bg2 {
		background: url('~@/assets/images/home/mobile_corporate_bg2.png') no-repeat;
		background-size: 100% 100%;
	}
	.introduce_bg3 {
		background: url('~@/assets/images/home/mobile_corporate_bg3.png') no-repeat;
		background-size: 100% 100%;
	}
}

/deep/.van-overlay {
	background-color: rgba(0, 0, 0, 0.5);
}
.van-popup {
	width: 300px;
	border-radius: 4px;
}
</style>
